import { Box, Portal, Text } from "@mantine/core";
import { useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";
import { TenantPill } from "../atoms";
import classes from "../../states.module.css";

// Workspace switch in progress (business-login / business-logout + /me). A
// module-level flag, because the switch is started from the header, the home
// page and the logo, and the overlay must outlive the route change it causes.
let switching = false;
const listeners = new Set<() => void>();

export function setSwitching(value: boolean) {
  if (switching === value) return;
  switching = value;
  listeners.forEach((l) => l());
}

const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
};

/** Full-screen loader while the workspace switches; same look as the boot check (app.tsx BootScreen). */
export function SwitchOverlay() {
  const active = useSyncExternalStore(subscribe, () => switching);
  return active ? <SwitchScreen /> : null;
}

/** The overlay itself, for pages that wait on a switch they did not start (main ?home=business). */
export function SwitchScreen() {
  const { t } = useTranslation("profileForm");
  return (
    <Portal>
      <Box className={`${classes.screen} ${classes.overlay}`}>
        <Box role="status" aria-live="polite" className={classes.boot}>
          <TenantPill size="md" />
          <Box className={classes.track} aria-hidden="true">
            <Box className={classes.bar} />
          </Box>
          <Text className={classes.bootText}>{t("states.switching")}</Text>
        </Box>
      </Box>
    </Portal>
  );
}
